import { z } from 'zod'

// === Sync Configuration ===

export const syncFrequencySchema = z.enum(['manual', 'daily', 'weekly'])

export type SyncFrequency = z.infer<typeof syncFrequencySchema>

export const syncStatusSchema = z.enum(['idle', 'pending', 'syncing', 'error'])

export type SyncStatus = z.infer<typeof syncStatusSchema>

export const urlSyncConfigRequestSchema = z.object({
  enabled: z.boolean().default(true),
  urls: z.array(z.string().url('URL invalida')).min(1, 'Pelo menos uma URL e obrigatoria'),
  frequency: syncFrequencySchema.default('manual'),
  crawl_depth: z.number().min(0).max(3).default(0),
  extract_clean_text: z.boolean().default(true),
})

export type UrlSyncConfigRequest = z.infer<typeof urlSyncConfigRequestSchema>

export const urlSyncConfigResponseSchema = z.object({
  enabled: z.boolean(),
  urls: z.array(z.string()),
  frequency: z.string(),
  crawl_depth: z.number(),
  extract_clean_text: z.boolean(),
  last_sync_at: z.string().datetime().nullable(),
  sync_status: z.string(),
})

export type UrlSyncConfigResponse = z.infer<typeof urlSyncConfigResponseSchema>

export const urlSyncTriggerResponseSchema = z.object({
  message: z.string(),
  status: z.string(),
  task_id: z.string().nullable(),
})

export type UrlSyncTriggerResponse = z.infer<typeof urlSyncTriggerResponseSchema>

// === UI Options ===

export const SYNC_FREQUENCY_OPTIONS = [
  { value: 'manual', label: 'Manual' },
  { value: 'daily', label: 'Diariamente' },
  { value: 'weekly', label: 'Semanalmente' },
] as const

export const CRAWL_DEPTH_OPTIONS = [
  { value: 0, label: 'Apenas a pagina', description: 'Nao segue links' },
  { value: 1, label: 'Profundidade 1', description: 'Segue links diretos' },
  { value: 2, label: 'Profundidade 2', description: 'Segue links de segundo nivel' },
  { value: 3, label: 'Profundidade 3', description: 'Segue links de terceiro nivel' },
] as const

// === Helper Functions ===

export function formatSyncDate(dateString: string | null): string {
  if (!dateString) return 'Nunca sincronizado'
  const date = new Date(dateString)
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function getSyncStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    idle: 'Disponivel',
    pending: 'Aguardando',
    syncing: 'Sincronizando',
    error: 'Erro',
  }
  return labels[status] || status
}

export function getSyncStatusColor(status: string): 'default' | 'secondary' | 'destructive' {
  const colors: Record<string, 'default' | 'secondary' | 'destructive'> = {
    idle: 'secondary',
    pending: 'default',
    syncing: 'default',
    error: 'destructive',
  }
  return colors[status] || 'secondary'
}
